import has from 'lodash/has';
import {
  EFT_ACCOUNT_NUMBER_REGXP,
  INSTITUTION_NUMBER_REGXP,
  BRANCH_NUMBER_REGXP,
} from '../../../constants/patterns';

export default function payoutEftPreSubmit(formData) {
  const errors = [];

  if (!has(formData, 'paymentOption') && !INSTITUTION_NUMBER_REGXP.test(formData.institutionNumber)) {
    errors.push({
      field: 'institutionNumber',
      // https://contegixapp1.livenation.com/confluence/display/LT/Payment+Options+API#PaymentOptionsAPI-error_codes
      errorKey: 'payment.errors.INVALID_FINANCIAL_INSTITUTION_NUMBER',
      currentValue: formData.institutionNumber,
    });
  }

  if (!has(formData, 'paymentOption') && !BRANCH_NUMBER_REGXP.test(formData.branchNumber)) {
    errors.push({
      field: 'branchNumber',
      // https://contegixapp1.livenation.com/confluence/display/LT/Payment+Options+API#PaymentOptionsAPI-error_codes
      errorKey: 'payment.errors.INVALID_BRANCH_NUMBER',
      currentValue: formData.branchNumber,
    });
  }

  if (!has(formData, 'paymentOption') && !EFT_ACCOUNT_NUMBER_REGXP.test(formData.accountNumber)) {
    errors.push({
      field: 'accountNumber',
      // https://contegixapp1.livenation.com/confluence/display/LT/Payment+Options+API#PaymentOptionsAPI-error_codes
      errorKey: 'payment.errors.INVALID_ACCOUNT_NUMBER',
      currentValue: formData.accountNumber,
    });
  }

  if (formData.firstName < 1) {
    errors.push({
      field: 'firstName',
      // https://contegixapp1.livenation.com/confluence/display/LT/Payment+Options+API#PaymentOptionsAPI-error_codes
      errorKey: 'payment.errors.INVALID_ACCOUNT_FIRSTNAME',
      currentValue: formData.firstName,
    });
  }

  if (formData.lastName < 1) {
    errors.push({
      field: 'lastName',
      // https://contegixapp1.livenation.com/confluence/display/LT/Payment+Options+API#PaymentOptionsAPI-error_codes
      errorKey: 'payment.errors.INVALID_ACCOUNT_LASTNAME',
      currentValue: formData.lastName,
    });
  }

  return errors;
}
